import { render, staticRenderFns } from "./TheGantt.vue?vue&type=template&id=2daf5f6c&"
import script from "./TheGantt.vue?vue&type=script&lang=js&"
export * from "./TheGantt.vue?vue&type=script&lang=js&"
import style0 from "./TheGantt.vue?vue&type=style&index=0&id=2daf5f6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports